import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AbstractDialogAuraComponent, DialogData } from '../../abstract/dialog.abstract.component';
import { DialogLayoutAuraComponent } from '../../layouts/dialog/dialog.component';

@Component({
  selector: 'aura-confirm-dialog',
  template: `
    <aura-dialog-layout [title]="data.title">
      <div dialog-content>
        <p>{{ data.message }}</p>
      </div>

      <div dialog-actions>
        <button mat-button [class]="data.confirm?.class" (click)="onConfirm()">
          {{ data.confirm?.text || 'Confirm' }}
        </button>
      </div>
    </aura-dialog-layout>
  `,
  imports: [DialogLayoutAuraComponent, MatButtonModule],
})
export class ConfirmDialogAuraComponent extends AbstractDialogAuraComponent<DialogData> {}
